export enum WetDogWeatherLayersEnum {
  MRMS = 0,
  XWEATHER_RADAR = 1,
  RADAR = 2,
  CLOUDCEILING = 3,
  CLOUDCOVER = 4,
  TEMPERATURE = 5,
  WINDUV = 6,
  WIND80M = 7,
  WINDGUST = 8,
  CASA_RADAR = 9,
}
